import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import HandleAbnormalOrderForm from './HandleAbnormalOrderForm'
import { fetchOrderDetail } from '@/redux/order/maternityCenterOrderSlice'

class HandleAbnormalOrderModal extends React.Component {
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleOk = async (formRef) => {
    // 处理异常订单提交已移除
    message.info('处理异常订单功能暂未开放')
    return false
  }

  handleCancel = () => {
    const { baseProps } = this.props
    const { onCancel } = baseProps || {}
    if (onCancel) {
      onCancel()
    }
  }

  render() {
    const { children, baseProps, title, staffListObj } = this.props
    const { orderId, orderDetail } = baseProps || {}

    const baseComponent = (
      <HandleAbnormalOrderForm
        orderDetail={orderDetail}
        staffListObj={staffListObj}
        dispatch={this.props.dispatch}
      />
    )

    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title || '处理异常订单'}
        width={700}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        centerTitle
        className="center-title-modal"
      />
    )
  }
}

// 使用函数组件作为wrapper来使用React Redux Hooks
const HandleAbnormalOrderModalWrapper = (props) => {
  const dispatch = useDispatch()
  const orderState = useSelector(state => state.order?.order || {})
  const dashboardState = useSelector(state => state.dashboard || {})
  const { detail } = orderState || {}
  const { data: orderDetail } = detail || {}
  const staffListObj = dashboardState.staffList || {}

  // 如果 baseProps 中有 orderId 但没有 orderDetail，则获取订单详情
  React.useEffect(() => {
    const { baseProps } = props
    const { orderId } = baseProps || {}
    if (orderId && !orderDetail) {
      dispatch(fetchOrderDetail(orderId))
    }
  }, [props.baseProps?.orderId, orderDetail, dispatch])

  const enhancedProps = {
    dispatch,
    baseProps: {
      ...props.baseProps,
      orderDetail: props.baseProps?.orderDetail || orderDetail
    },
    staffListObj,
    ...props
  }

  return <HandleAbnormalOrderModal {...enhancedProps} />
}

export default HandleAbnormalOrderModalWrapper

